module.exports = __webpack_public_path__ + "static/media/homePlatesIcon5.762395e2.png";